var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.994 91.5518C156.315 91.5518 145.226 80.4593 145.226 66.7759C145.226 53.0926 156.315 42 169.994 42C183.672 42 194.761 53.0926 194.761 66.7759C194.761 80.4593 183.672 91.5518 169.994 91.5518Z",
    fill: "#EA3377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3034 279.484C43.8187 235.417 77.5681 178.016 83.241 168.326C83.7549 166.568 84.4331 164.785 85.3683 162.991C92.11 149.847 99.16 136.853 106.354 123.946C98.7283 124.542 91.0823 125.133 83.462 125.724C78.2207 136.056 73.0052 146.393 67.7742 156.72C59.3523 173.359 34.4256 158.719 42.827 142.127C49.5686 128.798 57.559 98.8201 74.9629 97.4682C93.482 96.0289 111.996 94.5897 130.51 93.1556C130.962 93.1196 131.347 93.1813 131.779 93.1813C145.776 89.434 162.183 99.3136 165.153 113.588C174.618 134.092 188.209 150.104 211.014 156.786C228.865 162.009 221.26 189.905 203.332 184.662C180.79 178.062 164.598 165.139 152.322 148.13C144.887 161.392 137.626 174.736 130.669 188.265C145.966 198.818 159.331 211.581 171.042 226.308C174.31 230.415 174.87 234.64 173.77 238.357C173.812 239.745 173.724 241.184 173.329 242.747C168.822 260.594 164.321 278.41 159.809 296.236C155.025 315.234 124.96 309.837 129.785 290.715C134.076 273.727 138.372 256.738 142.662 239.74C131.902 227.048 119.215 216.007 104.72 207.762C101.308 205.819 99.16 203.141 97.9678 200.191C78.1385 230.59 58.304 272.647 38.485 298.138C26.389 313.692 2.19204 295.069 14.3034 279.484Z",
    fill: "#EA3377"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 239.551,
    y: 209.857,
    width: 37.8327,
    height: 85.4425,
    fill: "#FF3131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 314.791,
    y: 209.857,
    width: 37.4076,
    height: 85.4425,
    fill: "#68ADE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277.383,
    y: 209.857,
    width: 37.4076,
    height: 85.4425,
    fill: "#93E54B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.898 203.582C347.706 203.582 358.898 214.775 358.898 228.582V277C358.898 290.807 347.706 302 333.898 302H257C243.193 302 232 290.807 232 277V228.582C232 214.775 243.193 203.582 257 203.582H333.898Z",
    stroke: "#FF005F",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257 213.582H333.898C342.183 213.582 348.898 220.298 348.898 228.582V277C348.898 285.284 342.183 292 333.898 292H257C248.716 292 242 285.284 242 277V228.582C242 220.298 248.716 213.582 257 213.582Z",
    stroke: "#472037",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.537 171.464C270.584 169.512 267.419 169.512 265.466 171.464C263.513 173.417 263.513 176.583 265.466 178.535L272.537 171.464ZM295.67 201.668L299.205 198.133L272.537 171.464L269.001 175L265.466 178.535L292.134 205.204L295.67 201.668Z",
    fill: "#FF005F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.803 171.464C320.755 169.512 323.921 169.512 325.874 171.464C327.826 173.417 327.826 176.583 325.874 178.535L318.803 171.464ZM295.67 201.668L292.134 198.133L318.803 171.464L322.338 175L325.874 178.535L299.205 205.204L295.67 201.668Z",
    fill: "#FF005F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.dd44d4973f6dbdf5bf9928149e443ce0.svg";
export { ForwardRef as ReactComponent };